import React from "react";
import { createRoot } from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import globalReducer, { setTwoFactorRequired } from "state";
import { Provider } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";

import App from "./App";

import "./index.css";
import axios from "api/axios";

// Redux Store
const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
setupListeners(store.dispatch);

axios.interceptors.request.use((config) => {
  const viewAsRole = store.getState()?.global?.viewAsRole;
  if (viewAsRole) {
    config.headers = config.headers || {};
    config.headers["X-View-As-Role"] = viewAsRole;
  }
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location?.pathname || "";
      if (path !== "/login" && path !== "/home" && path !== "/") {
        try {
          sessionStorage.setItem("logout", "true");
        } catch {
          /* ignore */
        }
        window.location.replace("/login?error=session_expired");
      }
    }
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.code === "TWO_FACTOR_REQUIRED"
    ) {
      store.dispatch(setTwoFactorRequired(true));
    }
    return Promise.reject(error);
  }
);

// Rendering App
createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>
);
